import { Controller, useFormContext } from "react-hook-form";

interface IHiddenFieldProps {
  name: string;
  defaultValue?: any;
}

export const HiddenField = ({ name, defaultValue = "" }: IHiddenFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <input
          type="hidden"
          id={field.name}
          value={field.value ?? ""}
          onChange={(e) => field.onChange(e.target.value)}
        />
      )}
    />
  );
};
